<template>
    <v-row justify="center">
        <v-col cols="12" md="6">
            <v-card flat>
                <v-card-text>
                    <v-autocomplete
                        @input="updateTryouts"
                        v-model="selectedPeriod"
                        :items="autocompletePeriods"
                        label="Periode"
                    ></v-autocomplete>

                    <v-autocomplete
                        v-if="selectedPeriod"
                        v-model="selectedTryout"
                        :items="autocompleteTryouts"
                        label="Try Out"
                    ></v-autocomplete>

                    <v-btn
                        v-if="selectedTryout"
                        @click="add"
                        color="primary"
                        class="mt-4"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        tambah
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    data: () => ({
        periods: null,
        selectedPeriod: null,
        tryouts: null,
        selectedTryout: null,
    }),

    computed: {
        autocompletePeriods() {
            if (! this.periods) {
                return null
            }

            return this.periods
                .map(period => ({
                    text: period.title,
                    value: period.id
                }))
        },

        autocompleteTryouts() {
            if (! this.tryouts) {
                return null
            }

            return this.tryouts
                .map(tryout => ({
                    text: tryout.title,
                    value: tryout.hash
                }))
        }
    },

    methods: {
        async reset() {
            this.periods = null
            this.selectedPeriod = null
            this.selectedTryout = null

            const response = await this.$api.get('period')
            this.periods = response.data.periods
            this.periods.reverse()
        },

        async updateTryouts() {
            this.tryouts = null

            const response = await this.$api.get(`period/${this.selectedPeriod}/tryout`)

            this.tryouts = response.data.tryouts
        },

        add() {
            this.$emit('add', {
                period: this.periods.find(period => period.id == this.selectedPeriod),
                tryout: this.tryouts.find(tryout => tryout.hash == this.selectedTryout)
            })
        }
    },

    created() {
        this.reset()
    }
}
</script>
